import "./HeaderMenu.scss";
import { HashLink } from "react-router-hash-link";
import StyledButton from "../UI_Elements/Buttons/StyledButton";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Discord_logo from "../../../assets/common/discord-logo.svg";
import Twitter_logo from "../../../assets/common/twitter-logo.svg";
import Instagram_logo from "../../../assets/common/instagram-logo.svg";
import YT_Logo from "../../../assets/common/yt-logo.svg";

function XLink({ to, className, children }) {
    if (to.startsWith("http://") || to.startsWith("https://")) {
        return <a href={to} className={className} rel="noreferrer">{children}</a>;
    }
    return <HashLink to={to} className={className}>{children}</HashLink>;
}

function Desktop_HeaderMenu({ style, links, onMenuItemClick, ...otherProps }) {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const styles = { ...style };
    const [openDropdown, setOpenDropdown] = useState(null);

    // is this nav target the page we're on? ("/" must match exactly; others also match their sub-pages)
    const isCurrent = (value) =>
        typeof value === "string" && !value.startsWith("http") &&
        (value === "/" ? pathname === "/" : pathname === value || pathname.startsWith(value + "/"));

    const handleClick = (label, value) => {
        if (label === "LOGOUT") {
            onMenuItemClick();
        } else if (value.startsWith("http")) {
            window.location.href = value;
        } else {
            navigate(value);
        }
    };

    return (
        <div style={styles} className="HeaderMenu row w-100 h-100 justify-content-end align-items-center">
            <div className="HeaderMenuOptions Desktop col-auto d-flex">

                {Object.keys(links).map(label => {
                    const value = links[label];

                    if (typeof value === "object") {
                        return (
                            <div
                                key={label}
                                className="dropdown-container position-relative"
                                onMouseEnter={() => setOpenDropdown(label)}
                                onMouseLeave={() => setOpenDropdown(null)}
                            >
                                <div className={`MenuOption d-flex align-items-center px-2 ${Object.values(value).some(isCurrent) ? "is-active" : ""}`}>
                                    <h5 style={{ fontSize: 'clamp(0.7rem, 0.85vw, 0.9rem)', fontWeight: 700, letterSpacing: '0.04em', whiteSpace: 'nowrap', margin: 0, cursor: "pointer" }}>
                                        {label} ▼
                                    </h5>
                                </div>

                                {openDropdown === label && (
                                    <div className="dropdown-menu position-absolute" style={{
                                        backgroundColor: 'rgb(25, 6, 46)',
                                        minWidth: '180px',
                                        padding: '8px 0',
                                        zIndex: 10000
                                    }}>
                                        {Object.keys(value).map(sub => (
                                            <XLink
                                                key={sub}
                                                to={value[sub]}
                                                className="dropdown-item d-block px-4 py-2"
                                            >
                                                <h5 style={{ fontSize: 'clamp(0.7rem, 0.8vw, 0.85rem)', fontWeight: 600, margin: 0 }}>{sub}</h5>
                                            </XLink>
                                        ))}
                                    </div>
                                )}
                            </div>
                        );
                    }

                    return (
                        <div
                            key={label}
                            className={`MenuOption d-flex align-items-center px-2 px-lg-3 ${isCurrent(value) ? "is-active" : ""}`}
                            style={{ cursor: "pointer" }}
                            onClick={() => handleClick(label, value)}
                        >
                            <h5 style={{ fontSize: 'clamp(0.7rem, 0.85vw, 0.9rem)', fontWeight: 700, letterSpacing: '0.04em', whiteSpace: 'nowrap', margin: 0 }}>
                                {label}
                            </h5>
                        </div>
                    );
                })}

                <div className="ps-3">
                    <a href="https://app.adjust.com/1h9a99v0">
                        <StyledButton style={{ padding: '0.7em 1.5em' }}>
                            <h5 style={{ fontSize: 'clamp(0.7rem, 0.85vw, 0.9rem)', fontWeight: 800, color: '#442900', margin: 0, letterSpacing: '0.04em' }}>DOWNLOAD</h5>
                        </StyledButton>
                    </a>
                </div>
            </div>
        </div>
    );
}

const SOCIALS = [
    { label: "Discord", href: "https://discord.gg/aHEutBHp8d", icon: Discord_logo },
    { label: "Twitter", href: "https://twitter.com/HitwicketGame", icon: Twitter_logo },
    { label: "Instagram", href: "https://www.instagram.com/hitwicketsuperstars/", icon: Instagram_logo },
    { label: "YouTube", href: "https://www.youtube.com/@HitwicketGame", icon: YT_Logo },
];

const Chevron = ({ open }) => (
    <svg className={`MobileNav-chevron ${open ? "is-open" : ""}`} width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M9 6l6 6-6 6" />
    </svg>
);

function Mobile_HeaderMenu({ style, links, onMenuItemClick }) {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [expanded, setExpanded] = useState({});

    const handleClick = (label, value) => {
        if (label === "LOGOUT") {
            onMenuItemClick(label);
        } else {
            if (onMenuItemClick) onMenuItemClick(label);

            if (value.startsWith("http://") || value.startsWith("https://")) {
                window.location.href = value;
            } else {
                navigate(value);
            }
        }
    };

    return (
        <div style={style} className="HeaderMenu MobileNav-wrap">
            <nav className="MobileNav">
                {Object.keys(links).map(label => {
                    const value = links[label];

                    if (typeof value === "object") {
                        const isOpen = !!expanded[label];
                        return (
                            <div key={label} className="MobileNav-group">
                                <button
                                    type="button"
                                    className="MobileNav-item"
                                    aria-expanded={isOpen}
                                    onClick={() => setExpanded(prev => ({ ...prev, [label]: !prev[label] }))}
                                >
                                    <span className="MobileNav-label">{label}</span>
                                    <Chevron open={isOpen} />
                                </button>

                                {isOpen && (
                                    <div className="MobileNav-sub">
                                        {Object.keys(value).map(sub => (
                                            <XLink key={sub} to={value[sub]} className="MobileNav-subitem">
                                                {sub}
                                            </XLink>
                                        ))}
                                    </div>
                                )}
                            </div>
                        );
                    }

                    const isActive = !value.startsWith("http") && (value === "/" ? pathname === "/" : pathname.startsWith(value));
                    return (
                        <button
                            key={label}
                            type="button"
                            className={`MobileNav-item ${isActive ? "is-active" : ""}`}
                            onClick={() => handleClick(label, value)}
                        >
                            <span className="MobileNav-label">{label}</span>
                        </button>
                    );
                })}

                <a className="MobileNav-cta" href="https://app.adjust.com/1h9a99v0">DOWNLOAD</a>
            </nav>

            <div className="MobileNav-bottom">
                <div className="MobileNav-follow">
                    <div className="MobileNav-followTitle">FOLLOW US</div>
                    <div className="MobileNav-socials">
                        {SOCIALS.map(s => (
                            <a key={s.label} href={s.href} target="_blank" rel="noreferrer" aria-label={s.label}>
                                <img src={s.icon} alt="" />
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

function HeaderMenu({ device, ...props }) {
    return device === "mobile"
        ? <Mobile_HeaderMenu {...props} />
        : <Desktop_HeaderMenu {...props} />;
}

export default HeaderMenu;
